package com.jingfangpai.common.orm.mapping.enums

import org.jooq.ICatalog
import org.jooq.ISchema
import org.jooq.IEnumType
import kotlinx.serialization.Serializable

@Serializable
enum class SyndromeIndicationZangfuCombinedPathogenesis(private val literal: String) : IEnumType {
	心肾不交_心肾阴虚阳亢("心肾不交_心肾阴虚阳亢"),
	心脾气血虚_心脾两虚("心脾气血虚_心脾两虚"),
	肝火犯肺("肝火犯肺"),
	肝胃不和_肝气犯胃_肝胃气滞("肝胃不和_肝气犯胃_肝胃气滞"),
	肝脾不调_肝郁脾虚("肝脾不调_肝郁脾虚"),
	心肺气虚("心肺气虚"),
	脾肺气虚_脾肺两虚("脾肺气虚_脾肺两虚"),
	肺肾气虚_肾不纳气("肺肾气虚_肾不纳气"),
	心肾阳虚_水气凌心("心肾阳虚_水气凌心"),
	脾肾阳虚("脾肾阳虚"),
	心肝血虚("心肝血虚"),
	肝肾阴虚_肝肾虚火("肝肾阴虚_肝肾虚火"),
	肺肾阴虚("肺肾阴虚");
	override fun getCatalog(): ICatalog? {return null}
	override fun getSchema() :ISchema? {return null}
	override fun getName(): String? {return "syndrome_indication_zangfu_combined_pathogenesis"}
	override fun getLiteral(): String {return literal}
}
